/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Reformulation_BeforeInputs */

const en_keyword_optimizer_reformulation_before = /** @type {(inputs: Keyword_Optimizer_Reformulation_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current`)
};

const de_keyword_optimizer_reformulation_before = /** @type {(inputs: Keyword_Optimizer_Reformulation_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuell`)
};

const fr_keyword_optimizer_reformulation_before = /** @type {(inputs: Keyword_Optimizer_Reformulation_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actuel`)
};

const es_keyword_optimizer_reformulation_before = /** @type {(inputs: Keyword_Optimizer_Reformulation_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual`)
};

const it_keyword_optimizer_reformulation_before = /** @type {(inputs: Keyword_Optimizer_Reformulation_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attuale`)
};

const nl_keyword_optimizer_reformulation_before = /** @type {(inputs: Keyword_Optimizer_Reformulation_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huidig`)
};

const pl_keyword_optimizer_reformulation_before = /** @type {(inputs: Keyword_Optimizer_Reformulation_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecne`)
};

const fi_keyword_optimizer_reformulation_before = /** @type {(inputs: Keyword_Optimizer_Reformulation_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nykyinen`)
};

const da_keyword_optimizer_reformulation_before = /** @type {(inputs: Keyword_Optimizer_Reformulation_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuværende`)
};

const sv_keyword_optimizer_reformulation_before = /** @type {(inputs: Keyword_Optimizer_Reformulation_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuvarande`)
};

/**
* | output |
* | --- |
* | "Current" |
*
* @param {Keyword_Optimizer_Reformulation_BeforeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_reformulation_before = /** @type {((inputs?: Keyword_Optimizer_Reformulation_BeforeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Reformulation_BeforeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_reformulation_before(inputs)
	if (locale === "fr") return fr_keyword_optimizer_reformulation_before(inputs)
	if (locale === "es") return es_keyword_optimizer_reformulation_before(inputs)
	if (locale === "it") return it_keyword_optimizer_reformulation_before(inputs)
	if (locale === "nl") return nl_keyword_optimizer_reformulation_before(inputs)
	if (locale === "pl") return pl_keyword_optimizer_reformulation_before(inputs)
	if (locale === "fi") return fi_keyword_optimizer_reformulation_before(inputs)
	if (locale === "da") return da_keyword_optimizer_reformulation_before(inputs)
	if (locale === "sv") return sv_keyword_optimizer_reformulation_before(inputs)
	return en_keyword_optimizer_reformulation_before(inputs)
});